var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreLoudspeaker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 11V13H22.6602V11H18.6602ZM16.6602 17.61C17.6202 18.32 18.8702 19.26 19.8602 20C20.2602 19.47 20.6602 18.93 21.0602 18.4C20.0702 17.66 18.8202 16.72 17.8602 16C17.4602 16.54 17.0602 17.08 16.6602 17.61ZM21.0602 5.6C20.6602 5.07 20.2602 4.53 19.8602 4C18.8702 4.74 17.6202 5.68 16.6602 6.4C17.0602 6.93 17.4602 7.47 17.8602 8C18.8202 7.28 20.0702 6.35 21.0602 5.6ZM4.66016 9C3.56016 9 2.66016 9.9 2.66016 11V13C2.66016 14.1 3.56016 15 4.66016 15H5.66016V19H7.66016V15H8.66016L13.6602 18V6L8.66016 9H4.66016ZM16.1602 12C16.1602 10.67 15.5802 9.47 14.6602 8.65V15.34C15.5802 14.53 16.1602 13.33 16.1602 12Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreLoudspeaker);
export default __webpack_public_path__ + "static/media/icon-more-Loudspeaker.9574ed184056693dc07e7a6d5aa33064.svg";
export { ForwardRef as ReactComponent };